import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable, Subscription} from 'rxjs';
import {Incoming, IIncoming} from '../../shared/model/incoming.model';
import {IncomingService} from './incoming.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Transaction} from '../../shared/model/transaction.model';
import {NgxSpinnerService} from 'ngx-spinner';
import {Customer} from '../../shared/model/customer.model';
import {Organization} from "../../shared/model/organization.model";
import {Employee, IEmployee} from "../../shared/model/employee.model";
import {EmployeeService} from "../../core/employee/employee.service";
import * as moment from "jalali-moment";
import {IProject, Project} from "../../shared/model/project.model";
import {ISupplier, Supplier} from "../../shared/model/supplier.model";
import {SupplierService} from "../supplier/supplier.service";
import {IInstaller, Installer} from "../../shared/model/installer.model";
import {InstallerService} from "../installer/installer.service";
import {ProjectService} from "../project/project.service";
import {FactorService} from "../factor/factor.service";
import {IFactor} from "../../shared/model/factor.model";
import {Order} from "../../shared/model/order.model";


@Component({
  selector: 'app-incoming-update',
  templateUrl: './incoming-update.component.html',
  styleUrls: ['../order/order-add.component.scss']
})
export class IncomingUpdateComponent implements OnInit {
  incoming: IIncoming = new Incoming();
  isSaving: boolean;
  @Input() incomingEdit;
  @Input() required_project;
  @Input() transactionId;
  @Input() customerId;
  @Input() projectId;
  @Input() supplierId;
  @Input() installerId;
  @Input() required_supplier;
  @Input() required_installer;
  @Input() formType;
  @Input() factors;
  @Input() orderId;

  employees: IEmployee[];
  suppliers: ISupplier[];
  installers: IInstaller[];
  projects: IProject[];

  // dateObject: any;
  dateObject_reminder: any;
  dateObject2: any;
  dateTouched = false;
  partyTouched = false;
  fundCheckTouched = false;
  datePickerConfig = { appendTo: 'body' };

  currentAccount: any;
  incomings: IIncoming[];
  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  closeResult: string;
  showForm = false;
  commentObject: IIncoming = new Incoming();

  fundChecks: IIncoming[] = [];
  loadingFundChecks = false;
  selectedFundCheckId: number = null;
  selectedFundCheck: IIncoming = null;
  fundDueFromObject: any;
  fundDueToObject: any;
  fundCheckSortReverse: 'asc' | 'desc' = 'asc';

  constructor(protected incomingService: IncomingService, protected activatedRoute: ActivatedRoute, public activeModal: NgbActiveModal,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private employeeService: EmployeeService,
              private projectService: ProjectService,
              private factorService: FactorService,
              private supplierService: SupplierService,
              private installerService: InstallerService) {
    this.itemsPerPage = 20;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

  }

  ngOnInit() {
    this.isSaving = false;
    if (this.incomingEdit) {
      this.incomingService.find(this.incomingEdit).subscribe(
        (res: HttpResponse<IIncoming>) => {
          this.incoming = res.body;

          if (this.incoming.date) {
            const jalaliDate5 = moment(this.incoming.date).locale('fa').format('jYYYY/jM/jD HH:mm:ss');

            this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          if (this.incoming.factor) {
            this.incoming.factor_str = this.incoming.factor.id;
          }
          if (this.incoming.supplier) {
            this.incoming.supplier_str = this.incoming.supplier.id;
          }
          if (this.incoming.installer) {
            this.incoming.installer_str = this.incoming.installer.id;
          }

          this.numberWithCommasNumber();
          if (this.incoming.employee) {
            this.incoming.employee_str = this.incoming.employee.id;

          }
          if (this.incoming.type === 'fund_chek') {
            this.loadFundChecks();
          }
          if (!this.projectId && this.incoming.project && this.incoming.project.id) {
            this.projectId = this.incoming.project.id;
            this.loadProjectFactors();
          }
          if (!this.customerId) {
            if (this.incoming.customer && this.incoming.customer.id) {
              this.customerId = this.incoming.customer.id;
            } else if (this.incoming.project && this.incoming.project.customer && this.incoming.project.customer.id) {
              this.customerId = this.incoming.project.customer.id;
            }
          }

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
    if (this.customerId) {
      this.showForm = true;
    }
    if (this.transactionId) {
      this.loadAll();
    }
    this.loadAllEmployee();
    this.loadAllSuppliers();
    this.loadAllInstallers();
    this.loadAllProjects();
    this.loadProjectFactors();
    // this.activatedRoute.data.subscribe(({incoming}) => {
    //   this.incoming = incoming;
    // });
  }

  loadAll() {
    // this.incomingService
    //   .query({
    //     page: this.page - 1,
    //     size: this.itemsPerPage,
    //     sort: this.sort(this.predicate, this.reverse)
    //   })
    //   .subscribe(
    //     (res: HttpResponse<IIncoming[]>) => this.paginateIncomings(res.body, res.headers),
    //     (res: HttpErrorResponse) => this.onError(res.message)
    //   );
    if (this.transactionId) {
      this.spinner.show();
    }
    this.incomingService.findIncomingTransaction(
      this.transactionId).subscribe(
      (res: HttpResponse<IIncoming[]>) => {
        this.incomings = res.body;
        this.spinner.hide();

      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  sort(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }


  protected paginateIncomings(data: IIncoming[], headers: HttpHeaders) {
    // this.links = this.parseLinks.parse(headers.get('link'));
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.incomings = data;
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }

  showPartySection(): boolean {
    return !!(this.required_supplier || (this.required_installer && this.formType === 'payment'));
  }

  needsExactlyOneParty(): boolean {
    return this.formType === 'payment' && !!this.required_supplier && !!this.required_installer;
  }

  isSupplierRequiredAlone(): boolean {
    return !!this.required_supplier && !this.required_installer;
  }

  isInstallerRequiredAlone(): boolean {
    return !!this.required_installer && !this.required_supplier && this.formType === 'payment';
  }

  /** برای دریافت سفارش: بانک / دریافت‌کننده / فاکتور اجباری نیستند */
  requireBankReceiverFactor(): boolean {
    return this.formType !== 'payment' && !this.orderId;
  }

  hasBothSupplierAndInstaller(): boolean {
    return !!(this.incoming && this.incoming.supplier_str && this.incoming.installer_str);
  }

  hasPartySelected(): boolean {
    return !!(
      (this.incoming && this.incoming.supplier_str) ||
      (this.incoming && this.incoming.installer_str) ||
      this.supplierId ||
      this.installerId
    );
  }

  onSupplierChange(value: any) {
    this.partyTouched = true;
    if (value) {
      this.incoming.installer_str = null;
      this.incoming.installer = null;
    }
  }

  onInstallerChange(value: any) {
    this.partyTouched = true;
    if (value) {
      this.incoming.supplier_str = null;
      this.incoming.supplier = null;
    }
  }

  canSave(editForm?: any): boolean {
    if (this.isSaving) {
      return false;
    }
    if (editForm && editForm.form && editForm.form.invalid) {
      return false;
    }
    if (!this.dateObject2) {
      return false;
    }
    if (!this.incoming || !this.incoming.type || !this.incoming.amount) {
      return false;
    }
    if (this.hasBothSupplierAndInstaller()) {
      return false;
    }
    if (this.needsExactlyOneParty() && !this.hasPartySelected()) {
      return false;
    }
    if (this.isSupplierRequiredAlone() && !this.incoming.supplier_str && !this.supplierId) {
      return false;
    }
    if (this.isInstallerRequiredAlone() && !this.incoming.installer_str && !this.installerId) {
      return false;
    }
    if (this.incoming.type === 'fund_chek' && !this.selectedFundCheckId && !this.incoming.id) {
      return false;
    }
    if ((this.incoming.type === 'chek' || this.incoming.type === 'fund_chek') && !this.incoming.check_number) {
      return false;
    }
    return true;
  }

  save() {
    this.partyTouched = true;
    this.dateTouched = true;
    if (this.incoming && this.incoming.type === 'fund_chek') {
      this.fundCheckTouched = true;
    }
    if (!this.canSave()) {
      if (this.hasBothSupplierAndInstaller()) {
        alert('نمی‌توان همزمان پیمانکار و نصاب را انتخاب کرد.');
      } else if (this.needsExactlyOneParty() && !this.hasPartySelected()) {
        alert('لطفاً پیمانکار یا نصاب را انتخاب کنید.');
      } else if (this.incoming.type === 'fund_chek' && !this.selectedFundCheckId && !this.incoming.id) {
        alert('لطفاً یکی از چک‌های صندوق را انتخاب کنید.');
      }
      return;
    }
    this.isSaving = true;
    if (this.customerId) {
      this.incoming.customer = new Customer(this.customerId);
    }
    this.incoming.organization = new Organization(1);
    if (this.incoming.amount)
      this.incoming.amount = this.disNumberWithCommas(this.incoming.amount);


    const span_actionDate2 = document.getElementById('span_actionDate2');
    if (span_actionDate2) {
      this.incoming.date = new Date((<HTMLInputElement>span_actionDate2).innerHTML);
    }
    if (this.incoming.employee_str) {
      this.incoming.employee = new Employee(this.incoming.employee_str);
    }
    if (this.incoming.supplier_str) {
      this.incoming.supplier = new Supplier(this.incoming.supplier_str);
      this.incoming.installer = null;
      this.incoming.installer_str = null;
    } else {
      this.incoming.supplier = null;
    }
    if (this.incoming.factor_str) {
      this.incoming.factor = new Supplier(this.incoming.factor_str);
    }
    if (this.incoming.project_str) {
      this.incoming.project = new Project(this.incoming.project_str);
    }
    if (this.projectId) {
      this.incoming.project = new Project(this.projectId);
    }
    if (this.orderId) {
      this.incoming.order = new Order(Number(this.orderId));
    }
    if (this.customerId) {
      this.incoming.customer = new Customer(this.customerId);
    }
    if (this.supplierId && !this.incoming.installer_str) {
      this.incoming.supplier = new Supplier(this.supplierId);
    }
    if (this.installerId && !this.incoming.supplier_str) {
      this.incoming.installer = new Installer(this.installerId);
    }
    if (this.incoming.installer_str) {
      this.incoming.installer = new Installer(this.incoming.installer_str);
      this.incoming.supplier = null;
      this.incoming.supplier_str = null;
    } else if (!this.supplierId) {
      this.incoming.installer = null;
    }
    this.incoming.form_type = this.formType;

    if (this.incoming.type === 'credit') {
      this.incoming.status = 'notSettled';
    } else {
      this.incoming.status = 'settled';

    }
    if (this.incoming.paid === true) {
      this.incoming.status = 'settled';
    }
    // this.incoming.organization = new Organization(1);
    if (this.incoming.id !== undefined) {
      this.subscribeToSaveResponse(this.incomingService.update(this.incoming));
    } else {
      this.subscribeToSaveResponse(this.incomingService.create(this.incoming));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IIncoming>>) {
    result.subscribe((res: HttpResponse<IIncoming>) => this.onSaveSuccess(res), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess(res?: HttpResponse<IIncoming>) {
    if (this.incoming.type === 'fund_chek' && this.selectedFundCheckId) {
      this.markSourceCheckAsSpent(res && res.body ? res.body : this.incoming);
    } else {
      this.finishSaveSuccess();
    }
  }

  private markSourceCheckAsSpent(payment: IIncoming) {
    this.incomingService.find(this.selectedFundCheckId).subscribe(
      (res: HttpResponse<IIncoming>) => {
        const source = res.body;
        if (!source) {
          this.finishSaveSuccess();
          return;
        }
        const targetName = this.incoming.receiver
          || (this.incoming.supplier && this.incoming.supplier.title)
          || (payment && payment.receiver)
          || '';
        const checkNo = this.incoming.check_number || (source.check_number || '');
        source.spent_to = 'پرداخت از صندوق'
          + (checkNo ? (' / چک ' + checkNo) : '')
          + (targetName ? (' — ' + targetName) : '');
        this.incomingService.update(source).subscribe(
          () => this.finishSaveSuccess(),
          () => this.finishSaveSuccess()
        );
      },
      () => this.finishSaveSuccess()
    );
  }

  private finishSaveSuccess() {
    this.isSaving = false;
    this.showForm = false;
    this.loadAll();
    this.clear();
  }

  protected onSaveError() {
    this.isSaving = false;
  }

  onPaymentTypeChange(type: string, pickerTpl?: any) {
    if (type === 'fund_chek') {
      setTimeout(() => {
        if (pickerTpl) {
          this.openFundCheckPicker(pickerTpl);
        }
      }, 0);
    } else {
      this.fundChecks = [];
      this.selectedFundCheckId = null;
      this.selectedFundCheck = null;
    }
  }

  openFundCheckPicker(content: any) {
    if (!content) {
      return;
    }
    this.loadFundChecks();
    this.modalService.open(content, {
      windowClass: 'md fund-check-picker-modal',
      size: 'lg',
      backdrop: 'static',
      centered: true
    });
  }

  loadFundChecks() {
    this.loadingFundChecks = true;
    let startDate_from = '';
    let startDate_to = '';
    const spanFrom = document.getElementById('span_fund_due_from');
    const spanTo = document.getElementById('span_fund_due_to');
    if (spanFrom && this.fundDueFromObject) {
      startDate_from = (<HTMLInputElement>spanFrom).innerHTML;
    } else if (this.fundDueFromObject) {
      startDate_from = String(this.fundDueFromObject);
    }
    if (spanTo && this.fundDueToObject) {
      startDate_to = (<HTMLInputElement>spanTo).innerHTML;
    } else if (this.fundDueToObject) {
      startDate_to = String(this.fundDueToObject);
    }

    this.incomingService.searchReport({
      page: 0,
      size: 200,
      sort: ['date,' + this.fundCheckSortReverse],
      type: 'chek',
      form_type: 'receive',
      startDate_from,
      startDate_to,
      ...(this.customerId && this.formType === 'payment' ? {exclude_customer_id: this.customerId} : {})
    }).subscribe(
      (res: HttpResponse<IIncoming[]>) => {
        const rows = res.body || [];
        this.fundChecks = rows.filter(item =>
          (!item.spent_to || String(item.spent_to).trim() === '')
          && !this.isSameCustomerFundCheck(item)
        );
        this.loadingFundChecks = false;
      },
      () => {
        this.fundChecks = [];
        this.loadingFundChecks = false;
      }
    );
  }

  sortFundChecksByDueDate() {
    this.fundCheckSortReverse = this.fundCheckSortReverse === 'asc' ? 'desc' : 'asc';
    this.loadFundChecks();
  }

  private getCheckCustomerId(check: IIncoming): number | null {
    if (check.customer && check.customer.id) {
      return Number(check.customer.id);
    }
    if (check.project && check.project.customer && check.project.customer.id) {
      return Number(check.project.customer.id);
    }
    return null;
  }

  private isSameCustomerFundCheck(check: IIncoming): boolean {
    if (this.formType !== 'payment') {
      return false;
    }
    if (this.customerId) {
      const checkCustomerId = this.getCheckCustomerId(check);
      if (checkCustomerId !== null && checkCustomerId === Number(this.customerId)) {
        return true;
      }
    }
    if (this.projectId && check.project && check.project.id
      && Number(check.project.id) === Number(this.projectId)) {
      return true;
    }
    return false;
  }

  selectFundCheck(check: IIncoming, modal?: any) {
    if (!check) {
      return;
    }
    this.selectedFundCheck = check;
    this.selectedFundCheckId = check.id;
    this.incoming.check_number = check.check_number;
    if (check.amount) {
      this.incoming.amount = this.numberWithCommas(check.amount);
    }
    if (check.bank) {
      this.incoming.bank = check.bank;
    }
    if (check.date) {
      const jalaliDate5 = moment(check.date).locale('fa').format('jYYYY/jM/jD HH:mm:ss');
      this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
    }
    if (modal) {
      modal.close(check);
    }
  }

  getCheckDrawerName(check: IIncoming): string {
    if (!check) {
      return '-';
    }
    if (check.project && check.project.customer && (check.project.customer as any).title) {
      return (check.project.customer as any).title;
    }
    if (check.customer && (check.customer as any).title) {
      return (check.customer as any).title;
    }
    if (check.receiver) {
      return check.receiver;
    }
    return '-';
  }

  parseDateJalali(value: any): string {
    if (!value) {
      return '-';
    }
    try {
      return moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    } catch (e) {
      return '-';
    }
  }

  addComment() {
    this.showForm = true;
    this.incoming = new Incoming();
  }

  clearForm() {
    this.showForm = false;
    this.activeModal.dismiss('cancel');
  }

  clear() {
    this.showForm = false;
    this.activeModal.dismiss('cancel');
  }

  numberWithCommasNumber() {
    const cost = this.incoming.amount;

    const y = this.numberWithCommas(cost);
    this.incoming.amount = y;
  }


  numberWithCommas(x) {
    if (x === null || x === undefined || x === '') {
      return x;
    }

    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');
    x = x.toString().replace(',', '');

    const pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x)) {
      x = x.replace(pattern, '$1,$2');
    }
    return x;

  }

  disNumberWithCommas(x) {
    if (x) {
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');
      x = x.toString().replace(',', '');

      return x;
    }
  }

  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllSuppliers() {
    this.supplierService.query().subscribe(
      (res: HttpResponse<ISupplier[]>) => {
        this.suppliers = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllInstallers() {
    this.installerService.query().subscribe(
      (res: HttpResponse<IInstaller[]>) => {
        this.installers = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllProjects() {
    this.projectService
      .findWithSupplierId({
        page: this.page - 1,
        size: this.itemsPerPage,
        // sort: this.sort(this.predicate, this.reverse),
      }, this.supplierId)
      .subscribe(
        (res: HttpResponse<IProject[]>) => {
          this.projects = res.body;
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  loadProjectFactors() {
    if (!this.projectId) {
      return;
    }
    this.factorService.findWithPrjId({
      page: 0,
      size: 10000,
      sort: ['id,desc']
    }, this.projectId).subscribe(
      (res: HttpResponse<IFactor[]>) => {
        this.factors = res.body || [];
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllFactors() {
    this.factorService
      .query({
        page: this.page - 1,
        size: this.itemsPerPage,
        // sort: this.sort(this.predicate, this.reverse),
      })
      .subscribe(
        (res: HttpResponse<IFactor[]>) => {
          this.factors = res.body;
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

}
